<div class="videos-wrapper d-flex flex-wrap">
  <div class="video-item add-item d-flex flex-column align-items-center justify-content-center">
    <div class="icon">
      <svg viewBox="0 0 62 63">
        <use href="#new-add-video" />
      </svg>
    </div>
    <div class="title">Add a video</div>
  </div>
  <div class="video-item">
    <img src="/assets/new_img/Rectangle%2010.png" class="img-fluid" />
  </div>
  <div class="video-item">
    <img src="/assets/new_img/Rectangle%2010.png" class="img-fluid" />
  </div>
  <div class="video-item">
    <img src="/assets/new_img/Rectangle%2010.png" class="img-fluid" />
  </div>
  <div class="video-item">
    <img src="/assets/new_img/Rectangle%2010.png" class="img-fluid" />
  </div>
  <div class="video-item">
    <img src="/assets/new_img/Rectangle%2010.png" class="img-fluid" />
  </div>
  <div class="video-item">
    <img src="/assets/new_img/Rectangle%2010.png" class="img-fluid" />
  </div>
  <div class="video-item">
    <img src="/assets/new_img/Rectangle%2010.png" class="img-fluid" />
  </div>
  <div class="video-item">
    <img src="/assets/new_img/Rectangle%2010.png" class="img-fluid" />
  </div>
  <div class="video-item">
    <img src="/assets/new_img/Rectangle%2010.png" class="img-fluid" />
  </div>
  <div class="video-item">
    <img src="/assets/new_img/Rectangle%2010.png" class="img-fluid" />
  </div>
  <div class="video-item">
    <img src="/assets/new_img/Rectangle%2010.png" class="img-fluid" />
  </div>
  <div class="video-item">
    <img src="/assets/new_img/Rectangle%2010.png" class="img-fluid" />
  </div>
</div>
